import type { ActiveHaltBanner } from "../types";

// Top-of-app halt banner per UX §15.4 / §15.9-§15.12. ARIA assertive: a
// halt is consequential and the screen reader must announce it. The slot
// is defined in App.tsx; specific triggers (PF gap, AI cost ceiling,
// equity stop, bankroll cap) wire in as their backend state lands.

type Props = { banner: ActiveHaltBanner };

export const HaltBanner = ({ banner }: Props) => (
  <div className="tp-halt-banner" role="alert" aria-live="assertive">
    <div className="title">⚠ {banner.title}</div>
    <div className="body">{banner.body}</div>
  </div>
);
